'use strict';

var Emitter  = require('cjs-emitter'),
    parallel  = require('cjs-async/parallel'),

    sources = {},
    notificationStack = [],

    $widget = document.body.appendChild(document.createElement('div')),

    notify = function ( config ) {
        config.timeout = config.timeout || 5000;

        if ( config.buttons && config.buttons[0] && config.buttons[0].click ) {
            config.buttons[0].click();
            if ( Array.isArray(notificationStack) && notificationStack.length > 0 ) {
                notify(notificationStack.unshift());
            }
        } else {
            $widget.innerText = config.title;
            $widget.style.display = '';
            setTimeout(function () {
                $widget.style.display = 'none';
                if ( Array.isArray(notificationStack) && notificationStack.length > 0 ) {
                    notify(notificationStack.unshift());
                }
            }, config.timeout);
        }
    };


$widget.style.display = 'none';
$widget.style.textAlign = 'center';
$widget.style.background = '#000';
$widget.style.color = '#fff';
$widget.style.lineHeight = '72px';
$widget.style.height = 'auto';
$widget.style.position = 'absolute';
$widget.style.left = '0';
$widget.style.top = '0';
$widget.style.width = '100%';
$widget.style.zIndex = '9999';


function Core ( config ) {
    Emitter.call(this, config);

    this.plugins = {};

    this.applicationState = {
        focused: false,
        visible: false,
        home: false
    };
}

// inheritance
Core.prototype = Object.create(Emitter.prototype);
Core.prototype.constructor = Core;


Core.prototype.theme = {
    path: null
};

Core.prototype.environment = require('../system/environment');

Core.prototype.ready = false;

if ( !DEVELOP ) {
    Core.prototype.emit = function () {
        try {
            Emitter.prototype.emit.apply(this, arguments);
        } catch ( exception ) {
            if ( DEVELOP ) {
                debug('core')('ATTENTION! Exception in emit! ' + exception);
            }
        }
    };
}

Core.prototype.resolveDependencies = function ( applicationConfig, callback ) {
    var self = this,
        loaders = [];

    // if ( DEVELOP ) {
    //     if ( debug.enabled('plugin') ) {
    //         dependencyManager.load({
    //             dependencies: applicationConfig.dependencies,
    //             done: function ( error, plugins ) {
    //                 if ( DEVELOP ) {
    //                     debug('plugin')('dependencies load error: ' + error);
    //                 }

    //                 if ( plugins && plugins.length > 0 ) {
    //                     plugins.forEach(function ( plugin ) {
    //                         if ( DEVELOP ) {
    //                             debug('plugin')('prepare for load ' + plugin.packageName);
    //                         }

    //                         loaders.push(function ( done ) {
    //                             if ( DEVELOP ) {
    //                                 debug('plugin')('onAppInit prepare for ' + plugin.packageName);
    //                             }
    //                             plugin.instance.onAppInit({
    //                                 app: applicationConfig,
    //                                 options: plugin.options,
    //                                 storage: dependencyManager.getPluginStorage(plugin.name)
    //                             }, function ( error, instance ) {
    //                                 if ( DEVELOP ) {
    //                                     debug('plugin')(error);
    //                                     debug('plugin')('onAppInit done for ' + plugin.packageName);
    //                                 }
    //                                 self.plugins[plugin.name] = instance;
    //                                 done(error, instance);
    //                             });
    //                         });
    //                     });
    //                 }

    //                 if ( DEVELOP ) {
    //                     debug('plugin')('DEPENDENCIES LOAD START for ' + applicationConfig.name);
    //                 }
    //                 parallel(loaders, function ( error, plugins ) {
    //                     if ( DEVELOP ) {
    //                         debug('plugin')('DEPENDENCIES LOAD END for ' + applicationConfig.name);
    //                     }

    //                     callback(error, plugins);
    //                 });
    //             }
    //         });
    //     }

    //     return;
    // }

    if ( !self.ready ) {
        require('./plugin.loader').load({
            dependencies: applicationConfig.dependencies,
            done: function ( error, plugins ) {
                if ( DEVELOP ) {
                    debug('plugin')('dependencies load error: ' + error);
                }

                if ( plugins && plugins.length > 0 ) {
                    plugins.forEach(function ( plugin ) {
                        if ( DEVELOP ) {
                            debug('plugin')('prepare for load ' + plugin.packageName);
                        }

                        loaders.push(function ( done ) {
                            plugin.instance.onAppInit({
                                app: applicationConfig,
                                options: plugin.options,
                                storage: require('./plugin.loader').getPluginStorage(plugin.name),
                                path: plugin.path
                            }, function ( error, instance ) {
                                self.plugins[plugin.name] = instance;
                                done(error, instance);
                            });
                        });
                    });
                }

                if ( DEVELOP ) {
                    debug('plugin')('DEPENDENCIES LOADED');
                }

                parallel(loaders, callback);
            }
        });
    }
};


Core.prototype.notify = function ( config ) {
    // if base osd not loaded yet, call 'notify' can crush the application
    if ( notificationStack.length === 0 ) {
        notify(config);
    } else {
        notificationStack.push(config);
    }
};

Object.defineProperty(sources, 'INTENT', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 1
});

Object.defineProperty(sources, 'LAUNCHER', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 2
});

Object.defineProperty(sources, 'SYSTEM', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 3
});

Object.defineProperty(Core.prototype, 'SOURCES', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: sources
});


Object.defineProperty(sources, 'intent', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 1
});

Object.defineProperty(sources, 'launcher', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 2
});

Object.defineProperty(sources, 'system', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: 3
});

Object.defineProperty(Core.prototype, 'sources', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: sources
});


if ( PLATFORM === 'MAG' || NANOCORE ) {
    /* eslint new-cap: 0 */
    Core.prototype.apiVersion = parseInt(window.gSTB.Version().split(';')[0].split(':')[1], 10);
}


window.extendCorePrototype = function ( property, value ) {
    if ( DEVELOP ) {
        debug('kernel')('extendCorePrototype with ' + property);

        if ( property === 'backend' ) {
            value.requests = [];
            (function () {
                var originalRequest = value.request,
                    apiDebug = debug('backend-api-request');

                value.request = function ( url, options ) {
                    var eth0      = window.gSTB.GetLanLinkStatus(),
                        wifi      = window.gSTB.GetWifiLinkStatus(),
                        userAgent = 'Model: ' + window.gSTB.GetDeviceModelExt() + '; Link: ',
                        method    = options.method || 'GET',
                        request   = JSON.parse(JSON.stringify(options));


                    /* eslint no-nested-ternary: 0 */
                    request.method = method;
                    request.url = value.host + core.config.options.stalkerApiPath + url;

                    if ( request.headers ) {
                        request.headers['Authorization'] = 'Bearer ' + value.session.accessToken;
                        request.headers['Content-Type'] = 'application/json';
                        request.headers['Accept-Language'] = core.environment.language;
                        request.headers['X-User-Agent'] = userAgent + (eth0 && wifi ? 'Ethernet,WiFi' : wifi ? 'WiFi' : eth0 ? 'Ethernet' : '');
                    } else {
                        request.headers = {
                            Authorization: 'Bearer ' + value.session.accessToken,
                            'Content-Type': 'application/json',
                            'Accept-Language': core.environment.language,
                            'X-User-Agent': userAgent + (eth0 && wifi ? 'Ethernet,WiFi' : wifi ? 'WiFi' : eth0 ? 'Ethernet' : '')
                        };
                    }

                    //apiDebug('request: ' + method + ' ' + request.url);

                    //apiDebug('async: ' + request.async);

                    // remove properties with "undefined" values, so print incomplete information
                    //apiDebug('headers: ' + JSON.stringify(request.headers));

                    apiDebug(
                        'curl -X ' +
                        method + ' "' + request.url + '" -H ' +
                        Object.keys(request.headers).map(function ( key ) { return '"' + key + ': ' + request.headers[key] + '"'; }).join(' -H ') +
                        (options.body ? (' -d \'' + options.body + '\'') : '')
                    );

                    if ( options.type ) {
                        apiDebug('responseType: ' + options.type);
                    }

                    if ( options.timeout ) {
                        apiDebug('timeout: ' + options.timeout);
                    }

                    value.requests.push(request);

                    return originalRequest(url, options);
                };
            })();
        }
    }

    if ( property === 'notify' ) {
        notify = notificationStack = null;
        $widget.parentNode.removeChild($widget);
    }

    Core.prototype[property] = value;
};


module.exports = Core;
